import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Tabs } from 'antd';
import { useDispatch } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { ClientInfoForm, ClientAllSectionForm } from 'components/forms';
import { Box } from 'atoms';
import { getClientList } from 'store/clientSlice';

export default function CreateClientSection() {
	const defaultData = {
		banking_info: {},
		billing_info: [],
		crf_filename: {},
		document_info: {},
		other_info: {},
		shipping_info: [],
	};
	const [formData, setFormData] = useState(defaultData);
	const [otherFormsData, SetotherFormsData] = useState({});
	const [activeTab, setActiveTab] = useState(1);
	const [searchParams, setSearchParams] = useSearchParams();
	const dispatch = useDispatch();
	const { id } = useParams();

	const onChange = useCallback(
		(key) => {
			/**
			 * On Edit mode only allow to go other other tabs
			 */
			if (id) {
				const newQueryParameters = new URLSearchParams();
				console.log('newQueryParameters', newQueryParameters);
				setSearchParams({
					...newQueryParameters,
					tab: key,
					// isEdit: searchParams.get('isEdit') || false,
				});
				setActiveTab(key);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[id, setSearchParams, searchParams]
	);
	// const getData = () => {
	// 	if (searchParams.get('isEdit')) {
	// 		return !isEmpty(formData);
	// 	}
	// 	return false;
	// };
	useEffect(() => {
		const tab = Number(searchParams.get('tab'));

		if (tab) {
			onChange(tab);
		}
	}, [onChange, searchParams]);

	// const defaultForm = {
	// 	banking_info: {},
	// 	billing_info: [],
	// 	crf_filename: {},
	// 	document_info: {},
	// 	other_info: {},
	// 	shipping_info: [],
	// };

	useEffect(() => {
		console.log('Client Form activeTab', activeTab);
	}, [activeTab, formData]);

	useEffect(() => {
		if (id) {
			// console.log('id 2', id);
			dispatch(
				getClientList({
					search_type: 'client',
					filter_by: {
						id,
					},
				})
			).then((res) => {
				// console.log(res);
				// console.log('res', res?.data?.[0]);
				setFormData(res?.data?.[0]);
				SetotherFormsData(res?.data?.[0]);
				localStorage.setItem('formData', res?.data?.[0]);
			});
		}
	}, [dispatch, id]);

	console.log(formData);
	if (formData === undefined) {
		setFormData(defaultData);
	}
	if (isEmpty(formData)) {
		setFormData(defaultData);
	}

	const tabs = useMemo(
		() => [
			{
				id: 1,
				label: 'Client Details',
				form: (
					<ClientInfoForm
						isEditMode={Boolean(formData?.id)}
						otherFormsData={formData}
						formData={formData?.client_info}
						activeTab={activeTab}
					/>
				),
			},
			{
				id: 2,
				label: 'Required Details',
				form: (
					<ClientAllSectionForm
						isEditMode={Boolean(formData?.id)}
						formData={formData}
						otherFormsData={otherFormsData}
						activeTab={activeTab}
					/>
				),
			},
		],
		[formData, activeTab, otherFormsData]
	);

	return (
		<Box>
			<Tabs
				onChange={onChange}
				tabPosition="left"
				type="line"
				activeKey={activeTab}
				defaultActiveKey={1}
				items={tabs.map((tab) => ({
					label: `${tab.id}. ${tab.label}`,
					key: tab.id,
					children: tab.form,
				}))}
			/>
		</Box>
	);
}
